export class CopyConnectionItem {
    connectionName: string;
    copyProperties: boolean = false;
    copyAttributes: boolean = false;
    isNewConnection: boolean = false;
    sourceConnectionName: string = '';

    constructor(connectionName: string) {
        this.connectionName = connectionName;
    }
}
